// extracted by mini-css-extract-plugin
export default {"hiddenPagination":"hidden-pagination__hiddenPagination___J8a8T"};